import React, { createRef, useEffect, useMemo } from 'react';
import { useBookContext } from '../../BookContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useSearchParams } from 'react-router-dom';
import BookLesson from '../../BookLesson';
import { ChapterType, getChapterIndex } from '../../../../../ui/src/common/book/BookHelpers';

const BookChapterDetailCustom: React.FC<{ chapterId: string }> = ({
  chapterId,
}) => {
  const { book } = useBookContext();
  const chapter = useMemo(() => book.chapters.find((c) => c.id === chapterId), [
    book,
    chapterId,
  ]);
  const [searchParams, setSearchParams] = useSearchParams();
  const ref = createRef<HTMLDivElement>();

  const handleGoBack = () => {
    ref.current?.classList.add('disappear');
    setTimeout(() => {
      ref.current?.classList.remove('disappear');
      ref.current?.classList.add('appear');
      searchParams.delete('chapter');
      setSearchParams(searchParams);
    }, 500);
  };
  useEffect(() => {
    ref.current?.classList.add('appear');
    // eslint-disable-next-line
  }, []);
  return (
    chapter && (
      <div className="chapter-content" ref={ref}>
        <div className="chapter-content-header">
          <FontAwesomeIcon
            className="icon-back"
            icon={faArrowLeft}
            onClick={handleGoBack}
          />
          <div
            className={`chapter-detail ${
              chapter?.type === ChapterType.Review && 'chapter-review'
            }`}>
            <div className="chapter-name">{chapter.name}</div>
            <div className="chapter-index">
              {getChapterIndex(book.chapters, book.chapters.indexOf(chapter))}
            </div>
            <div className="chapter-title">{chapter.title}</div>
          </div>
        </div>
        <div className="chapter-lesson">
          {chapter.lessons.map((lesson, index) => (
            <BookLesson key={index} lesson={lesson}
            />
          ))}
        </div>
      </div>
    )
  );
};

export default BookChapterDetailCustom;
